import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getPathologyList = async (
  pageNumber,
  pageSize,
  sortField,
  sortOrder
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PATHALOGYLIST,
      {
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
      },
      {
        withCredentials: true,
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getModalityList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.MODALITYLIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSubModalityList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SUBMODALITYLIST, {
      withCredentials: true,
      data: {
        paginationDto: body.paginationDto,
        listNumber: body.listNumber,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveNewSubModality = async (saveSubModalityDto) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SAVESUBMODALITY, saveSubModalityDto
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editExistingSubModality = async (editSubModalityDto) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITSUBMODALITY, editSubModalityDto
      // {
      //   data: {
      //     id: editSubModalityDto.id,
      //     serviceName: editSubModalityDto.serviceName,
      //     expirationTime: editSubModalityDto.expirationTime
      //   }
      // }
       
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getErrorCodeList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.ERRORCODELIST, {});
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyErrorSearchList = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ERRORSEARCHLIST,
      {
        data: {
          errorListsSearchDto: payload,
        },
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyErrorList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ERRORSTUDYLIST,
      {},
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAnnotationList = async (body) => {
  try {
    const response1 = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/annotation/list",
      {
        data: {
          paginationDto: body.paginationDto,
        },
      }
    );
    return response1;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addAnnotationApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/annotation/add  ",
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getViewAnnotationDetail = async (payload) => {
  try {
    const response1 = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/annotation/view",
      { data: { id: payload.id } }
    );
    return response1;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportTemplatesList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTTEMPLATESLIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStylesList = async (refreshFlag = 0) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}jwtServices/api/agentic/styles?refresh=${refreshFlag}`,
      {
        withCredentials: true, 
      }
    );
    console.log("response is :", response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addOrUpdateStyle = async (styleData) => {
  try {
    const endpoint = styleData.id 
      ? "jwtServices/api/agentic/styles/update"
      : "jwtServices/api/agentic/styles";
      
    const response = await axiosInterceptor.post(
      API_BASE_URL + endpoint,
      styleData,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportTemplatesListByTab = async (activeTab, body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL +
        SERVICEURL +
        APIs.REPORTTEMPLATESLISTBYTAB +
        `/${activeTab}`,
      {
        withCredentials: true,
        data: {
          paginationDto: body.paginationDto,
          modalityIds: body.modalityIds,
          clientIds: body.clientIds,
          radiologistIds: body.radiologistIds
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ADDREPORTTEMPLATE,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.EDITREPORTTEMPLATEAPI,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DELETEREPORTTEMPLATE,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getRadiologistList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTRADIOLOGIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHeaderTemplateList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETHEADERTEMPLATE,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getFirmsList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTFIRMS, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getClientsList = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.REPORTCLIENTS + "/" + firmId,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const updateDefaultHeaderTemplate = async (reportId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATEDEFAULTHEADERTEMPLATE,
      {
        data: {
          masterStudyReportId: reportId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getViewReportTemplateDetail = async (reportId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITREPORTTEMPLATE, {
      data: {
        reportTemplateId: reportId,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteStyleApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/api/agentic/styles/delete",
      { id: payload.id },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};